export default {
  adLength: 2,
  budget: 0,
  adType: 'ad_only',
  previousAdType: null,
  name: '',
  searchId: null,
  endCardEnabled: true,
  instagramAccount: null,
  link: null,
  linkAnalyzed: null,
};
